import type { ThemeConfig, ThemeName } from '../types/theme.types.js';

export const THEME_STORAGE_KEY = 'app-theme-name';

export const THEME_CLASS_MAP: Record<ThemeName, string> = {
  light: '',
  dark: 'dark',
  'high-contrast': 'high-contrast',
  'dark-high-contrast': 'dark high-contrast',
  system: '', // Resolved dynamically based on OS preference
};

export const THEME_CONFIGS: Record<ThemeName, ThemeConfig> = {
  light: {
    name: 'light',
    mode: 'light',
    isHighContrast: false,
  },
  dark: {
    name: 'dark',
    mode: 'dark',
    isHighContrast: false,
  },
  'high-contrast': {
    name: 'high-contrast',
    mode: 'light',
    isHighContrast: true,
  },
  'dark-high-contrast': {
    name: 'dark-high-contrast',
    mode: 'dark',
    isHighContrast: true,
  },
  system: {
    name: 'system',
    mode: 'light', // Default, resolved dynamically at runtime
    isHighContrast: false,
  },
};

export const DEFAULT_THEME: ThemeName = 'system';

export const THEME_NAMES: ThemeName[] = ['system', 'light', 'dark', 'high-contrast', 'dark-high-contrast'];

export const THEME_LABELS: Record<ThemeName, string> = {
  system: 'System',
  light: 'Light',
  dark: 'Dark',
  'high-contrast': 'High Contrast',
  'dark-high-contrast': 'Dark High Contrast',
};
